import { useQuery } from '@tanstack/react-query';
import { message, Statistic } from 'antd';
import React from 'react';
import { FIVE_MINUTES } from '../../constants/CONSTANTS';
import { fetchAPI } from '../../utils/api';
import {
  makeOrderListV2Payload,
  useOrderV2QueryParams,
} from './OrderListV2/OrderListingV2';

const OrderCorrectedEmailReader: React.FC = () => {
  const [queryParams] = useOrderV2QueryParams();
  const query = useQuery<{
    loading: boolean;
    corrected_email_reader_po: number;
  }>(
    ['corrected-email-reader-orders', queryParams],
    async () => {
      try {
        const payload = makeOrderListV2Payload(queryParams);
        const resp = await fetchAPI('order/corrected-count', {
          method: 'POST',
          payload: {
            ...payload,
            filters: {
              ...payload.filters,
              is_corrected: true,
            },
          },
        });

        return { ...resp, loading: false };
      } catch (error) {
        message.error("Failed get corrected email reader's orders count");
        return {
          loading: false,
          corrected_email_reader_po: -1,
        };
      }
    },
    {
      staleTime: FIVE_MINUTES,
      placeholderData: {
        loading: true,
        corrected_email_reader_po: 0,
      },
    }
  );

  return (
    <>
      <Statistic
        title={`Corrected Email Reader Order`}
        loading={query.data.loading}
        value={query.data.corrected_email_reader_po}
        style={{
          display: 'inline-block',
          width: 'fit-content',
        }}
      />
    </>
  );
};

export default OrderCorrectedEmailReader;
